import React, { useContext, useState } from 'react';
import { useFetch } from '../api/useFetch';
import { useUserContext } from './user_context';

export const InventoryContext = React.createContext();


export const InventoryProvider = ({ children }) => {

    const { btoken, stoken } = useUserContext();

    let data = { btoken, stoken };

    // GET INVENTORIES 
    const {
        loading: inventoryLoading, data: allInventory, fetchData: getInventoryData
    } = useFetch('/getInventories', data);

    const {
        loading: invtDataLoading, data: allInvtData, fetchData: getInvtData
    } = useFetch('/dashboard.invt', data);

    const [showAddInventory, setShowAddInventory] = useState(false);
    const CloseAddInventory = () => setShowAddInventory(false);
    const openAddInventory = () => setShowAddInventory(true);

    const [showEditInventory, setShowEditInventory] = useState(false);
    const CloseEditInventory = () => setShowEditInventory(false);
    const openEditInventory = () => setShowEditInventory(true);


    return (
        <InventoryContext.Provider value={{

            showAddInventory, CloseAddInventory, openAddInventory,
            showEditInventory, CloseEditInventory, openEditInventory,

            inventoryLoading, allInventory, getInventoryData,
            invtDataLoading, allInvtData, getInvtData,

        }}>
            {children}
        </InventoryContext.Provider>
    );
};

// make sure use
export const useInventoryContext = () => {
    return useContext(InventoryContext);
};
